(() => {
  document.body.classList.add('ah-at-home-loaded');

  const pages = document.querySelectorAll('[data-at-home-page]');

  pages.forEach((page) => {
    const items = page.querySelectorAll('[data-ah-reveal]');

    if (!items.length || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((item) => item.classList.add('ah-is-visible'));
      return;
    }

    page.classList.add('ah-is-enhanced');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('ah-is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    items.forEach((item, index) => {
      item.style.transitionDelay = `${Math.min(index % 4, 3) * 70}ms`;
      observer.observe(item);
    });
  });
})();
